<template>
  <v-dialog v-model="isShown">
    <GmapMap
      :center="center"
      :zoom="zoom"
      map-type-id="terrain"
      style="width: 100%; height: 500px"
      :options="{
        zoomControl: true,
        mapTypeControl: true,
        scaleControl: true,
        streetViewControl: true,
        rotateControl: true,
        fullscreenControl: true,
        disableDefaultUi: false
      }"
    >
      <GmapMarker v-if="position" :position="position" :draggable="true" @drag="updateCoordinates" />
    </GmapMap>
    <div class="location-footer">
      <v-btn @click="submit" :style="{ borderColor: btnBgColor, color: btnBgColor }" class="mr-5 loc-btn">Submit</v-btn>
      <v-btn @click="cancel" :style="{ borderColor: btnBgColor, color: btnBgColor }" class="loc-btn">Cancel</v-btn>
    </div>
  </v-dialog>
</template>

<script>
import { EventBus } from 'components-system';

export default {
  name: 'LocationModal',
  data() {
    return {
      isShown: false,
      center: { lat: 0, lng: 0 },
      zoom: 1,
      position: null,
    }
  },
  created() {
    EventBus.$off('location-modal');
    EventBus.$on('location-modal', (pos) => {
      if (pos) {
        this.zoom = 8;
        this.center = pos;
        this.position = pos;
      }

      this.isShown = true;
    });
  },
  methods: {
    updateCoordinates(location) {
      this.position = {
        lat: location.latLng.lat(),
        lng: location.latLng.lng(),
      };
    },
    submit() {
      EventBus.$emit('location-modal:submit', this.position);
      this.isShown = false;
    },
    cancel() {
      this.isShown = false;
    }
  },
  computed: {
    btnBgColor() {
      return this.$store.getters['theme/btnBgColor'];
    }
  }
};
</script>

<style lang="scss" scoped>
  .location-footer {
    text-align: center;
    background-color: #fff;
    padding: 1rem;
  }
  .loc-btn {
    border-style: solid;
    border-width: 1px;
    box-shadow: none;
    background-color: #fff i !important;
  }
</style>
